<script>
import baseList from "@/views/components/base/baseList.vue";

let customerId = window.localStorage.getItem("customerId");
import { Tag, Button } from "view-design";
import Vue from "vue";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "floor",
        key: "id",
        url: {
          list: "/admin/system/floor/list",
          del: "/admin/system/floor",
        },
        output: false,
      },
      // menus: [
      //   {
      //     label: "常用语",
      //     name: "commondescr_list_main",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "工单类型",
      //     name: "worktype_list",
      //     auth: "system/worktype/index",
      //   },
      //   // {
      //   //   label: "供应商",
      //   //   name: "supplier_main",
      //   //   auth: "system/supplier/index",
      //   // },
      //   {
      //     label: "资产类型",
      //     name: "deviceClass_list",
      //     auth: "system/deviceClass/index",
      //   },
      //   {
      //     label: "型号库",
      //     name: "deviceType_list",
      //     auth: "",
      //   },
      //   {
      //     label: "耗材分类",
      //     name: "consumablesClass_list",
      //     auth: "system/consumablesClass/index",
      //     show: !(Number(customerId) === 0),
      //   },
      //   {
      //     label: "楼宇管理",
      //     name: "offices_building_list",
      //     auth: "system/offices/index",
      //   },
      //   // {
      //   //   label: "巡检模板",
      //   //   name: "templateManagement_list",
      //   //   auth: "system/templateManagement/index",
      //   // },
      //   {
      //     label: "巡检类别",
      //     name: "category_list",
      //     auth: "system/category/index",
      //   },
      //   {
      //     label: "巡检项",
      //     name: "scene_list",
      //     auth: "system/scene/index",
      //   },
      //   {
      //     label: "坐席列表",
      //     name: "callConfig_list",
      //     auth: "/admin/callConfig/lists",
      //   },

      //   {
      //     label: "投诉管理",
      //     name: "feedback_list",
      //     auth: "/admin/feedback/lists",
      //   },
      //   {
      //     label: "流程管理",
      //     name: "approvalProcess_list",
      //     auth: "",
      //   },

      // ],
      actions: [
        {
          label: "新增楼宇楼层",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
        {
          label: "增加楼层",
          icon: "md-add",
          type: "info",
          onClick: this.toEdit,
          auth: "",
        },
        {
          label: "删除楼宇",
          type: "info",
          onClick: this.toDelet,
          auth: "",
        },
      ],
      filters: [],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "楼宇名称",
          key: "buildingName",
          align: "center",
        },
        {
          title: "楼层名称",
          key: "floorName",
          align: "center",
        },
        {
          title: "科室",
          key: "deskNames",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            let textArr = row.deskNames;
            let textStr = textArr.join("、");
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content={textStr}
                placement="top-start"
                popper-class="tooltip-dynamic-width"
                style={{ "--tooltip-width": "50%" }}
              >
                <div class="two-lines-ellipsis">{textStr}</div>
              </el-tooltip>
            );
          },
        },
        {
          title: "设备",
          key: "facilityNames",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            let textArr = row.facilityNames;
            let textStr = textArr.join("、");
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content={textStr}
                placement="top-start"
                popper-class="tooltip-dynamic-width"
                style={{ "--tooltip-width": "50%" }}
              >
                <div class="two-lines-ellipsis">{textStr}</div>
              </el-tooltip>
            );
          },
        },

        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
          auth: {
            edit: "system/building/edit",
            del: "system/floor/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    //选中
    handleSelect(selected) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
      }
      this.selected = ids_arr.join(",");
    },
    toAdd() {
      $utils.url.push({
        name: "offices_building_edit",
        query: { action: "add" },
      });
    },
    toEdit() {
      $utils.url.push({ name: "offices_floor_edit", query: { action: "add" } });
    },

    toDelet() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要删除的楼宇");
        return true;
      }
      let ids = this.selected;
      $utils.api
        .load(`/admin/system/floor/floor/${ids}`, {}, "POST")
        .then((res) => {
          if (res.status) {
            $utils.toast.success("删除成功");
            this.search();
          }
        });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "offices_building_edit",
        query: {
          action: "edit",
          kv: currentRow.id,
          buildingId: currentRow.buildingId,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .two-lines-ellipsis {
  /* 必须设置宽度，否则无法触发溢出 */
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis; /* 部分浏览器需要 */
}
</style>
